import { writable } from "svelte/store";
export function createSessionStore(initial, storageKey) {
    const store = writable(initial);
    try {
        const value = sessionStorage.getItem(storageKey);
        if (value) {
            store.set(JSON.parse(value));
        }
    }
    finally {
        store.subscribe(value => {
            sessionStorage.setItem(storageKey, JSON.stringify(value));
        });
        return store;
    }
}
